import { useQueryClient, useMutation } from '@tanstack/react-query';

import { Query } from './api';

export const useBasicAPIMutation = (accountId, typePlural) => {
  const queryClient = useQueryClient();
  const basePath = `accounts/${accountId}/${typePlural}`;

  return useMutation({
    mutationFn: async (instance) => {
      const options = {
        httpMethod: 'post',
      };

      if (instance.id) {
        options.httpMethod = 'patch';
      }

      return await new Query(basePath, null, options)
        .setData(instance.toAPI(), instance.id)
        .run();
    },
    onSuccess: (instance) => {
      queryClient.invalidateQueries([accountId, typePlural]);
      queryClient.setQueryData([accountId, typePlural, instance.id], instance);
      if (instance.name) {
        queryClient.setQueryData(
          [accountId, typePlural, instance.name],
          instance,
        );
      }
    },
    onError: (error) => {
      console.error('Error updating instance:', error);
    },
  });
};
